<template>
    <div class="reviews-list__text">
        <span v-safe-html="renderedText"></span>
        <div tabindex="0" class="toggler swiper-no-swiping" @click="toggle" ref="toggler"
             v-if="review.trim().length > maxLength">
            <span>{{ togglerText }}</span>
        </div>
    </div>
</template>

<script>
import { safeHtmlDirective } from '../assets/js/_safeHtml';

export default {
    directives: { safeHtml: safeHtmlDirective },
    name: "ReviewText",
    props: {
        review: String,
    },
    data() {
        return {
            showAll: false,
            maxLength: 80,
        }
    },
    methods: {
        toggle() {
            this.showAll = !this.showAll;
            this.$refs.toggler.blur();

            this.$nextTick(() => this.$emit('clampchange'));
        },
    },
    computed: {
        renderedText() {
            return (this.showAll || this.review.trim().length < this.maxLength) ? this.review : (this.review.replace(/&nbsp;/g, ' ').slice(0, this.maxLength) + '...')
        },
        togglerText() {
            return this.showAll ? 'Свернуть' : 'Подробнее';
        },
    },

}
</script>

<style lang="scss" scoped>
.toggler {
    outline: none;
}
</style>
